import getLiveElement from '../../../accessors/get-live-element';
import getAdvancedSelection from '../../../../text-formatting/accessors/get-advanced-selection';
import findFirstTextNode from '../../../../content-editable/helpers/find-first-text-node';
import findLastTextNode from '../../../../content-editable/helpers/find-last-text-node';

/*
  The handler is intended to:
    - detect of all text selection (cmd+a hotkey)
    - correct the native selection of Firefox browser
 */

const selectAllTextHotkeyProcessing = (focusedElementId) => {
  const focusedElement = getLiveElement(focusedElementId);
  const selection = getAdvancedSelection();
  const { anchorNode, focusNode, isCollapsed } = selection;

  if (!anchorNode || !focusNode || isCollapsed) {
    return false;
  }

  if (anchorNode === focusNode && anchorNode === focusedElement) {
    const { ownerDocument: liveDocument } = focusedElement;
    const firstNode = findFirstTextNode(focusedElement);
    const lastNode = findLastTextNode(focusedElement);

    if (firstNode) {
      const range = liveDocument.createRange();

      range.setStart(firstNode, 0);

      if (lastNode) {
        range.setEnd(lastNode, lastNode.length);
      }

      selection.removeAllRanges();
      selection.addRange(range);
      selection.refresh();
    }

    return true;
  }

  return false;
};

export default selectAllTextHotkeyProcessing;
